"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itCountry = void 0;
var _utils = require("../utils");
var _companyNumber = require("../../companyNumber");
// i18next-extract-mark-ns-start Countries

var itCountry = exports.itCountry = function itCountry(t) {
  return {
    id: 'IT',
    name: t('Italy'),
    flag: '🇮🇹',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      return (zipcode === null || zipcode === void 0 ? void 0 : zipcode.length) === 5;
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 00118 or 20121',
    phonePrefix: '39',
    phoneLength: 10,
    pricingVersion: 14,
    timezone: 'Europe/Rome',
    currency: 'EUR',
    companyNumber: {
      label: _companyNumber.labels.IT,
      checker: _companyNumber.checkers.IT,
      placeholder: '00159560366'
    }
  };
};